import qs from 'qs'

var config = {
  authType: process.env.VUE_APP_AUTH_TYPE,
  loginUrl: process.env.VUE_APP_OAUTH_LOGIN_URL,
  loginOutUrl: process.env.VUE_APP_OAUTH_LOGOUT_URL,
  authorizationUrl: process.env.VUE_APP_OAUTH_AUTH_URL,
  clientId: 'GDEE_HP',
  clientSecret: '2Jr2wDtH',
  scope: 'all',
  // eslint-disable-next-line no-undef
  redirectUri: process.env.VUE_APP_WEB_SERVER + '/#/oauth-callback',
  getAuthorizeUrl: function (state) {
    const url = this.authorizationUrl + '?' + qs.stringify({
      client_id: this.clientId,
      response_type: 'code',
      redirect_uri: this.redirectUri,
      scope: this.scope,
      state: state
    })

    return url
  },

  getLoginUrl: function () {
    return this.loginUrl
  },

  getAuthType: function () {
    return this.authType
  },

  getLogOutUrl: function () {
    return this.loginOutUrl
  }

}

export default config
